import pl from './pl';
// import cz from './cz';
// import de from './de';
import en from './en';

const locale = {
  'en-GB': en,
  'pl-PL': pl,
  // 'cs-CZ': cz,
  // 'de-DE': de,
};

export default locale;
